import React from 'react';
import Media from '../components/Media';

const MediaPage: React.FC = () => {
  return (
    <div className="pt-16">
      <Media />
    </div>
  );
};

export default MediaPage;
